import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useUser } from '../context/UserProvider';
import LoadingScreen from './LoadingScreen';
import { isAdminUser } from '../utils/isAdminUser';

function AdminRoute({ children }) {
  const { user: kipUser, firebaseUser, initialized } = useUser();

  if (!initialized) {
    return <LoadingScreen />;
  }

  if (!firebaseUser && !kipUser) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdminUser(kipUser)) {
    return <Navigate to="/home" replace />;
  }

  return children;
}

AdminRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AdminRoute;
